import { MediaBlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/mediaBlock/mediaBlock.layout'
import { MediaBlock } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/blocks.state'
import { StyleguideExample, StyleguidePart } from '@shared/Hoppinger.Styleguide/Frontend'
import * as React from 'react'
import { dummyData, randomCaption, randomTitle } from '../../../config/dummyData'

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------  STYLEGUIDE RENDERER  ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentsMediaBlock = () => (
  <>
    <StyleguidePart title="Image" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentMediaBlock mediaType="image" />
      </StyleguideExample>
    </StyleguidePart>

    <StyleguidePart title="Video" intro="">
      <StyleguideExample showExampleLabel={false} isFullScreen={false}>
        <ComponentMediaBlock mediaType="video" />
      </StyleguideExample>
    </StyleguidePart>
  </>
)

// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ----------        SNIPPETS       ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------
// ---------- ---------- ---------- ---------- ---------- ----------

export const ComponentMediaBlock = (props: {
  mediaType: MediaBlock['items'][number]['mediaType']
  items?: MediaBlock['items']
}) => (
  <MediaBlockLayout
    id="media-block-example"
    videoCookieAccepted={true}
    title={randomTitle()}
    intro={dummyData.intro}
    items={
      props.items ||
      (props.mediaType == 'image'
        ? [
            {
              mediaType: 'image',
              image: dummyData.image,
              caption: randomCaption(),
              displayOption: 'content-width'
            },
            {
              mediaType: 'image',
              image: dummyData.image,
              caption: randomCaption(),
              displayOption: 'full-width'
            }
          ]
        : [
            {
              mediaType: 'video',
              caption: randomCaption(),
              url: dummyData.videoYouTube,
              provider: 'youtube',
              displayOption: 'content-width'
            },
            {
              mediaType: 'video',
              caption: randomCaption(),
              url: dummyData.videoVimeo,
              provider: 'vimeo',
              displayOption: 'full-width'
            }
          ])
    }
  />
)
